import { render, staticRenderFns } from "./RecentClaims.vue?vue&type=template&id=608752e2&"
import script from "./RecentClaims.vue?vue&type=script&lang=js&"
export * from "./RecentClaims.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports